import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import { isEmpty } from '@/utils/resultsHelper';
import { datasourceTestIcon } from '../helper';
import { externalDatasourceTypes } from '../constants';
import { validateDatasourceDatabaseFieldsForTest } from './DatasourceDatabaseFields';
import { validateDatasourceTokenFieldsForTest } from './DatasourceTokenFields';

export const testDatasourceValidators = {
  [externalDatasourceTypes.POSTGRES]: validateDatasourceDatabaseFieldsForTest,
  [externalDatasourceTypes.SQL_SERVER]: validateDatasourceDatabaseFieldsForTest,
  [externalDatasourceTypes.SYNAPSE]: validateDatasourceDatabaseFieldsForTest,
  [externalDatasourceTypes.FEDERATED_NODE]: validateDatasourceTokenFieldsForTest,
};

const DatasourceTestButton = ({
  connection,
  disabled,
  iconOnly,
  onClick,
  testStatus,
}) => {
  const intl = useIntl();
  const testIcon = datasourceTestIcon({ connection });
  return (
    <Button
      className="aridhia-modal-left-butto"
      icon
      labelPosition={iconOnly ? undefined : 'right'}
      negative={connection === false}
      positive={connection === true}
      secondary={isEmpty(connection)}
      loading={testStatus === states.PENDING}
      onClick={disabled ? null : () => onClick()}
      disabled={disabled}
      data-tooltip={testStatus === states.PENDING ? undefined : intl.formatMessage({ id: testIcon.alt })}
      data-position="right center"
    >
      {!iconOnly && (<FormattedMessage id="test.dataset.datasource" />)}
      <Icon name={testIcon.name} alt={intl.formatMessage({ id: testIcon.alt })} />
    </Button>
  );
};

export default DatasourceTestButton;
